<script setup lang="ts">
/** Statut de synchronisation (spec §10) : « Synchronisé », « En attente », « Conflit », « Hors ligne ». */
import { fr } from '@/copy/fr'

import type { IconName } from '../icons/registry'
import Icon from './Icon.vue'

type SyncStatus = 'synced' | 'pending' | 'conflict' | 'offline'

withDefaults(defineProps<{ status: SyncStatus; count?: number }>(), { count: undefined })

const LOOK: Record<SyncStatus, { icon: IconName; tone: string }> = {
  synced: { icon: 'check', tone: 'text-positive' },
  pending: { icon: 'sync', tone: 'text-ink-muted' },
  conflict: { icon: 'alert', tone: 'text-danger' },
  offline: { icon: 'offline', tone: 'text-ink-muted' },
}
</script>

<template>
  <span :class="['inline-flex items-center gap-1 text-caption font-medium', LOOK[status].tone]">
    <Icon :name="LOOK[status].icon" :size="16" />
    {{ fr.ui.sync[status] }}<template v-if="count !== undefined">&nbsp;({{ count }})</template>
  </span>
</template>
